import axios from "axios";
import { backendUrl } from "../url";

const API = axios.create({
  baseURL: backendUrl, // or http://localhost:8000 if local
  withCredentials: true, // ✅ send HttpOnly cookies for auth
});

/* ---------------------------- STORE API ---------------------------- */
export const saveStoreName = (data) => API.post("/saveStoreName", data);
export const saveStorePhone = (data) => API.post("/saveStorePhone", data);
export const saveStoreEmail = (data) => API.post("/saveStoreEmail", data);
export const saveStoreBillingAddress = (data) => API.post("/saveStoreBillingAddress", data);
export const saveStore = (data) => API.post("/saveStore", data);
export const getStoreDetails = () => API.get("/getStoreDetails");

/* --------------------------- PRODUCT API --------------------------- */
export const saveProduct = (formData) => API.post("/saveProduct", formData);
export const getProducts = () => API.get("/getProducts");
export const getSingleProduct = (id) => API.get(`/getSingleProduct?id=${id}`);
export const deleteProduct = (id) => API.delete(`/deleteProducts?id=${id}`);
export const editProduct = (data) => API.put("/editProduct", data);

/* -------------------------- COLLECTION API ------------------------- */
export const createCollection = (data) => API.post("/createCollection", data);
export const getCollections = () => API.get("/getCollections");
export const getSingleCollection = (id) => API.get(`/getSingleCollection?id=${id}`);
export const updateCollection = (data) => API.put("/updateCollection", data);
export const getCategories = () => API.get("/getCategories");
export const deleteFromCollections = (id) => API.delete(`/deleteFromCollections?id=${id}`);

/* --------------------------- INVENTORY API ------------------------- */
export const addLocation = (data) => API.post("/addLocation", data);
export const getInventoryLocations = () => API.get("/getInventoryLocations");
export const getInventoryProducts = () => API.get("/getInventoryProducts");

/* ----------------------------- ORDER API --------------------------- */
export const getOrders = () => API.get("/getOrders");
export const getCurrentOrders = () => API.get("/getCurrentOrders");
export const updateOrderStatus = (data) => API.post("/updateOrderStatus", data);

/* ------------------------------ USER API --------------------------- */
export const getUsers = () => API.get("/getUsers");
export const getSearchedUser = (query) => API.get(`/getSearchedUser?query=${query}`);

/* ----------------------------- AUTH API ---------------------------- */
export const login = (data) => API.post("/login", data);
export const signUp = (data) => API.post("/signUp", data);
export const logout = () => API.post("/logout");

/* ---------------------------- COUPON API --------------------------- */
export const createCoupon = (data) => API.post("/createCoupon", data);
export const getCoupons = () => API.get("/getCoupons");
export const deleteCoupons = (id) => API.delete(`/deleteCoupons?id=${id}`);
export const getCouponData = (id) => API.get(`/getCouponData?id=${id}`);

/* ---------------------------- Enquiry API --------------------------- */
export const createEnquiry = (data) => API.post('/createEnquiry', data);

/* ------------------------------ SITE API --------------------------- */
export const addImageToSiteLocation = (formData) =>
  API.post("/addImageToSiteLocation", formData);

/* -------------------------- EXPORT DEFAULT ------------------------- */
export default API;





